import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { faClosedCaptioning, faSearch, faStop } from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'app-corporate-account-search-box',
  templateUrl: './corporate-account-search-box.component.html',
  styleUrls: ['./corporate-account-search-box.component.scss']
})
export class CorporateAccountSearchBoxComponent implements OnInit {
  @Input() placeholder!: string;
  @Output() keyupEnter = new EventEmitter<any>();
  @Output() iconSearch = new EventEmitter<any>();
  icons = {
    search: faSearch,
  }
  valueLength: any;
  search = ''
  constructor() { }

  ngOnInit(): void {

  }

  sendInput(input: any) {
    if (input.target.value) {
      this.keyupEnter.emit(input.target.value);
      // return (this.value = null);
    } else {
      this.keyupEnter.emit('');
    }
    
  }

  getLength(input: any) {
    this.valueLength = input.target.value.length

  }
  
  clearInput() {
    this.search = ''
    this.keyupEnter.emit('');
    this.valueLength = 0
  }


  iconClick(key: any) {
    this.iconSearch.emit(key);

  }

}
